import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function PageLoader(){
 const {pathname}=useLocation();
 const [visible,setVisible]=useState(true);

 useEffect(()=>{
   setVisible(true);
   window.scrollTo({top:0,left:0,behavior:'auto'});
   const id=window.setTimeout(()=>setVisible(false),pathname==='/'?620:430);
   return()=>window.clearTimeout(id);
 },[pathname]);

 return <AnimatePresence>
  {visible&&<motion.div className="page-loader" data-nosnippet initial={{opacity:1}} exit={{opacity:0,transition:{duration:.28,ease:'easeOut'}}} aria-hidden="true">
    <div className="page-loader-inner">
      <img src="/brand/xynysys-icon.png" alt=""/>
      <div className="page-loader-word">XYNYSYS</div>
      <div className="page-loader-line"><motion.i initial={{scaleX:0}} animate={{scaleX:1}} transition={{duration:.48,ease:[.2,.8,.2,1]}}/></div>
      <span>SOFTWARE · AI · CLOUD</span>
    </div>
  </motion.div>}
 </AnimatePresence>
}
